(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("mggp-player"));
	else if(typeof define === 'function' && define.amd)
		define(["mggp-player"], factory);
	else if(typeof exports === 'object')
		exports["mggp-plugin-kibana-warnings"] = factory(require("mggp-player"));
	else
		root["mggp-plugin-kibana-warnings"] = factory(root["mggp-player"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE_mggp_player__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/mggp-plugin-kibana-warnings.js");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./src/estimateBandwidth.js":
/*!**********************************!*\
  !*** ./src/estimateBandwidth.js ***!
  \**********************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var mapHeightToResolution = function mapHeightToResolution(videoEl, availableResolutions) {
  if (!availableResolutions.length) return -1;
  if (!videoEl) return availableResolutions[0].bitrate;
  var closestDiffs = availableResolutions.map(function (val) {
    return Math.abs(val.bitrate - videoEl.videoHeight);
  });
  var closest = Math.min.apply(null, closestDiffs);
  var v = availableResolutions[closestDiffs.findIndex(function (e) {
    return e === closest;
  })];
  return v.bitrate;
};

var canDowngrade = function canDowngrade(currentBitrate, availableResolutions) {
  var bitrates = availableResolutions.filter(function (_ref) {
    var bitrate = _ref.bitrate;
    return bitrate > 0;
  }).map(function (_ref2) {
    var bitrate = _ref2.bitrate;
    return bitrate;
  });
  return Math.min.apply(null, bitrates) < currentBitrate;
};

module.exports = {
  mapHeightToResolution: mapHeightToResolution,
  canDowngrade: canDowngrade
};

/***/ }),

/***/ "./src/mggp-plugin-kibana-warnings.js":
/*!********************************************!*\
  !*** ./src/mggp-plugin-kibana-warnings.js ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by Роман on 20.10.2016.
 */



var Plugin = __webpack_require__(/*! mggp-player */ "mggp-player").Plugin;

var _require = __webpack_require__(/*! ./estimateBandwidth */ "./src/estimateBandwidth.js"),
    mapHeightToResolution = _require.mapHeightToResolution,
    canDowngrade = _require.canDowngrade;
/**
 * @class MggpPluginQuality
 */

var MggpPluginKibanaWarnings = function MggpPluginKibanaWarnings() {
    Plugin.apply(this, arguments);

    var BUFFERING = 'buff_v2';

    var self = this;
    var _player = self.player;

    var _bufferingTimeStart = null;
    var _bufferingTime = 0;
    var _elapsedTimeAfterBuffering = 0;
    var _lastTimestamp = void 0;
    var _needToCountAfterBufferingTime = false;
    var _primaryBufferTime = 0;

    this.dispose = function () {
        _needToCountAfterBufferingTime = false;
        _player.off('player:buffering', onPlayerBuffering);
        _player.off('player:timeUpdate', onTimeUpdate);
        _player.off('property:videoInfo', onVideoInfo);
        _player = null;
    };

    var onPlayerBuffering = function onPlayerBuffering(pEvent) {
        var isBuffering = pEvent.data.isBuffering;
        var timestamp = pEvent.data.timestamp;
        var isSeeking = pEvent.data.isSeeking;

        if (isBuffering && !isSeeking) {
            _bufferingTimeStart = timestamp;
            _needToCountAfterBufferingTime = false;
            _primaryBufferTime = getBufferTime();
        } else if (!isBuffering && _bufferingTimeStart != 0) {
            _bufferingTime = timestamp - _bufferingTimeStart;
            fireEventByType(BUFFERING);
            _bufferingTimeStart = 0;
            _needToCountAfterBufferingTime = true;
            _elapsedTimeAfterBuffering = 0;
        }
    };

    function onTimeUpdate(event) {
        var timestamp = Math.floor(new Date().getTime() / 1000);
        if (_needToCountAfterBufferingTime && _player.get('state') === 1) {
            _elapsedTimeAfterBuffering += timestamp - _lastTimestamp;
        }
        _lastTimestamp = timestamp;
    }

    function onVideoInfo(event) {
        _lastTimestamp = void 0;
        _elapsedTimeAfterBuffering = 0;
        _bufferingTimeStart = 0;
        _bufferingTime = 0;
    }

    var fireEventByType = function fireEventByType(pType) {

        var videoInfo = _player.get('videoInfo') || {};
        var version = self.config.version || self.config.appVersion || '';
        var position = self.player.get('position');

        if (typeof position !== 'number') {
            try {
                position = parseInt(position);
            } catch (error) {
                position = -1;
            }
        }

        if (position <= 0) return;

        position = Math.floor(position * 1000);

        var device = self.config.device || self.config.deviceInfo || null;

        if (!device && self.config.deviceID) {
            device = { device_id: self.config.deviceID };
        } else {
            device = {};
        }

        var estimate_quality = mapHeightToResolution(_player.getPlayableElement(), _player.get('qualityList'));
        var can_downgrade = canDowngrade(estimate_quality, _player.get('qualityList'));

        var message = {
            "cdn_host": findCdnHost(),
            "src": _player.get('src') || videoInfo.src,
            "platform": self.config.deviceType.toUpperCase(),
            "device": device,
            "os": self.config.deviceOS || '',
            "app_version": version.toString(),
            "video_id": videoInfo.video_id.toString(),
            "user_id": self.config.userID ? self.config.userID.toString() : '',
            "auto_quality": _player.get('quality') == -1,
            "video_quality": _player.get('quality') == -1 ? 'Auto' : _player.get('quality') + 'p',
            "estimate_quality": estimate_quality === -1 ? 'Auto' : estimate_quality + 'p',
            "can_downgrade": can_downgrade,
            "buffering_time": _bufferingTime,
            "drm_type": '',
            "stream_type": '',
            "buffer_time": getBufferTime(),
            "primary_buffer_time": _primaryBufferTime,
            "play_time": _elapsedTimeAfterBuffering,
            "position": position,
            "content_type": videoInfo.content_type || '',
            "is_embed": videoInfo.is_embed ? videoInfo.is_embed : false
        };

        var ext;
        if (videoInfo.src) {
            ext = _player.utils.getExtension(videoInfo.src);
        }

        if (ext == 'm3u8') message.stream_type = 'hls';
        if (ext == 'mpd') message.stream_type = 'dash';
        if (ext == 'mp4') message.stream_type = 'mp4';
        if (ext == 'wvm') message.stream_type = 'download';

        if (videoInfo.drm_type != "") message.drm_type = videoInfo.drm_type;

        if (self.config.api_key) {
            message.api_key = self.config.api_key;
        }

        message.type = pType;
        message.buffering_time = _bufferingTime + (100 - _bufferingTime % 100);

        message = clearMessage(message); //MHP-269

        _player.emit('kibana:player_warnings', message);

        _bufferingTime = 0;
    };

    var clearMessage = function clearMessage(pMessage) {
        var clear = {};

        for (var props in pMessage) {
            if (pMessage[props] !== '' && pMessage[props] !== -1) {
                clear[props] = pMessage[props];
            }
        }

        return clear;
    };

    var findCdnHost = function findCdnHost() {
        var host = '';
        var qualityList = _player.get('qualityList');
        if (qualityList) {
            var regExp = /vs.+\.vcdn.biz/;
            for (var i = 0; i < qualityList.length; i++) {
                if (!qualityList[i] || !qualityList[i].src) {
                    continue;
                }
                if (regExp.test(qualityList[i].src)) {
                    var cdnHost = qualityList[i].src.match(regExp)[0];
                    host = cdnHost.split('.')[0];
                    break;
                }
            }
        }
        return host;
    };

    function getBufferTime() {
        var result = -1;
        var video = self.player.getPlayableElement();
        if (video && video.buffered && video.buffered.length > 0) {
            var i = video.buffered.length;
            var pos = self.player.get('position');
            while (i--) {
                if (video.buffered.start(i) <= pos && video.buffered.end(i) >= pos) {
                    result = Math.floor((video.buffered.end(i) - pos) * 1000);
                }
            }
        }
        return result;
    }

    _player.on('player:buffering', onPlayerBuffering);
    _player.on('player:timeUpdate', onTimeUpdate);
    _player.on('property:videoInfo', onVideoInfo);
};

MggpPluginKibanaWarnings.prototype = Object.create(Plugin.prototype);
MggpPluginKibanaWarnings.prototype.constructor = MggpPluginKibanaWarnings;
module.exports = MggpPluginKibanaWarnings;

/***/ }),

/***/ "mggp-player":
/*!******************************!*\
  !*** external "mggp-player" ***!
  \******************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_mggp_player__;

/***/ })

/******/ });
});